import React from 'react';
import { API_ENDPOINT_URL } from '~data/constants/app';

import { Item, ItemIcon, ItemTitle, Button, Icon } from '~ui';
import { LongDateTime } from '~modules/format/date';

export default function SettingsBackupsFilesItem({ _id, created }) {
  return (
    <Item>
      <ItemIcon>
        <Icon name='cache_ready' />
      </ItemIcon>
      <ItemTitle>
        <LongDateTime date={created} />
      </ItemTitle>

      <div className='relative z-[1] flex [&>:not(:last-child)]:mr-px'>
        <Button
          asChild
          variant='ghost'
          size='sm'
        >
          <a href={`${API_ENDPOINT_URL}backup/${_id}.html`} download>
            <Icon name='download' size='micro' />
            HTML
          </a>
        </Button>

        <Button asChild variant='ghost' size='sm'>
          <a href={`${API_ENDPOINT_URL}backup/${_id}.csv`} download>
            <Icon name='download' size='micro' />
            CSV
          </a>
        </Button>
      </div>
    </Item>
  );
}
